(function($) {
	$(document).ready(function(){

		$('.hamburger-menu').on('click', function(){
			$('.resp-menu-overlay').toggleClass('show');
			$('body').toggleClass('disable-scroll');
		});

	});
})(jQuery); // Fully reference jQuery after this point.